// Gestionnaire global pour la popup de comparaison
window.ComparisonPopup = {
	element: null,

	init() {
		this.element = document.getElementById('comparison-popup');
		if (!this.element) return;

		// Gestionnaires d'événements
		const closeBtn = document.getElementById('comparison-popup-close');
		const confirmBtn = document.getElementById('comparison-popup-confirm');
		const overlay = this.element.querySelector('.comparison-popup__overlay');

		if (closeBtn) {
			closeBtn.addEventListener('click', () => this.hide());
		}

		if (confirmBtn) {
			confirmBtn.addEventListener('click', () => this.hide());
		}

		if (overlay) {
			overlay.addEventListener('click', () => this.hide());
		}

		// Fermer avec Escape
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && this.isVisible()) {
				this.hide();
			}
		});
	},

	show(title, message) {
		if (!this.element) return;

		// Mettre à jour le contenu
		const titleElement = document.getElementById('comparison-popup-title');
		const messageElement = document.getElementById('comparison-popup-message');

		if (titleElement) {
			titleElement.textContent = title || titleElement.textContent;
		}

		if (messageElement) {
			messageElement.textContent = message || messageElement.textContent;
		}

		// Afficher la popup
		this.element.style.display = 'flex';

		// Forcer un reflow puis ajouter la classe visible
		this.element.offsetHeight;
		this.element.classList.add('is-visible');

		// Empêcher le scroll du body
		document.body.style.overflow = 'hidden';
	},

	hide() {
		if (!this.element) return;

		this.element.classList.remove('is-visible');

		// Cacher après l'animation
		setTimeout(() => {
			this.element.style.display = 'none';
			document.body.style.overflow = '';
		}, 300);
	},

	isVisible() {
		return this.element && this.element.classList.contains('is-visible');
	},
};

// Initialiser quand le DOM est prêt
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		window.ComparisonPopup.init();
	});
} else {
	window.ComparisonPopup.init();
}
